var React = require('react');

function AddressPrimary (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 13H1.85701V0H0V13ZM2.78552 8.93669H13V0H2.78552V8.93669Z"}));
}

AddressPrimary.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"#1B4521"};

module.exports = AddressPrimary;

AddressPrimary.default = AddressPrimary;
